import React from 'react';

// Minimal, dependency-free confirmation dialog (specs/010-pricing-comparison-enhancements US3,
// research.md Decision 8 — no modal library exists in this React tree, and this one's needs
// (a title, a sentence of body copy, Cancel/Confirm) don't justify adding one).
export default function ConfirmDialog({title, body, cancelLabel, confirmLabel, onCancel, onConfirm}) {
    return (
        <div
            className="position-fixed d-flex align-items-center justify-content-center"
            style={{top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', zIndex: 1050}}
            onClick={onCancel}
        >
            <div
                className="card rounded-corners p-4"
                style={{maxWidth: '420px', width: '90%'}}
                onClick={(event) => event.stopPropagation()}
            >
                <h5>{title}</h5>
                <p className="text-muted">{body}</p>
                <div className="d-flex justify-content-end mt-3">
                    <button type="button" className="btn secondary-button mr-2" onClick={onCancel}>{cancelLabel}</button>
                    <button type="button" className="btn primary-button" onClick={onConfirm}>{confirmLabel}</button>
                </div>
            </div>
        </div>
    );
}
